/**
 * Slots do Google Ad Manager (GPT) exibidos abaixo do FAQ.
 *
 * O `gpt.js` é carregado em `public/index.html`; cada slot é definido em
 * `GoogleBannerAd` a partir destes valores. Na página de alertas os blocos são
 * próprios (não reaproveitam os da home), então cada um tem relatório
 * individual no GAM e não precisa de key-value para identificar a página.
 */
export type FaqAdSlot = {
  /** Id do `<div>` do slot (o mesmo usado em `googletag.display`) */
  slotId: string;
  /** Caminho da unidade de anúncio no GAM */
  adUnit: string;
  /** Tamanhos aceitos pelo slot, no formato do GPT */
  sizes: number[][];
};

export type FaqAds = {
  /** Banner exibido em telas largas (desktop) */
  desktop: FaqAdSlot;
  /** Banners empilhados em telas menores */
  mobile: FaqAdSlot[];
};

/** Anúncios abaixo do FAQ da home. */
export const HOME_FAQ_ADS: FaqAds = {
  desktop: {
    slotId: "div-gpt-ad-1748630982557-0",
    adUnit: "/27140001/footer_728x90",
    sizes: [[970, 90]],
  },
  mobile: [
    {
      slotId: "div-gpt-ad-1748863026720-0",
      adUnit: "/27140001/300x250_HomeMob",
      sizes: [[300, 250]],
    },
    {
      slotId: "div-gpt-ad-1748862917989-0",
      adUnit: "/27140001/320x50_HomeMob",
      sizes: [
        [234, 60],
        [300, 100],
        [320, 50],
        [300, 50],
        [320, 100],
      ],
    },
  ],
};

/** Anúncios entre o FAQ e o texto institucional da página de alertas. */
export const ALERTS_FAQ_ADS: FaqAds = {
  desktop: {
    slotId: "div-gpt-ad-1791378045407-0",
    adUnit: "/27140001/alertas_faq_institucional_970x90",
    sizes: [[970, 90]],
  },
  mobile: [
    {
      slotId: "div-gpt-ad-1791378156924-0",
      adUnit: "/27140001/alertas_faq_institucional_300x250",
      sizes: [[300, 250]],
    },
    {
      slotId: "div-gpt-ad-1791378227101-0",
      adUnit: "/27140001/alertas_faq_institucional_320x50",
      sizes: [[320, 50]],
    },
  ],
};
